import 'twin.macro';
import React from 'react';
import Dialog from '@teetsh/app/src/components/Dialog';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { CondensedOption } from './CondensedOption';
import Cards from '@teetsh/app/src/components/RadioGroups/Cards';
import { CheckIcon as Check } from '@heroicons/react/24/outline';
import { useCJConfigurationDisplay } from '@teetsh/app/src/containers/CahierJournal/useCJConfigurationDisplay';
import { useTranslation } from 'react-i18next';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export function CJViewSettingsModal(props: Props) {
  const { isOpen, onClose } = props;
  const { guestMode } = useUser();
  const {
    expanded,
    setItemsExpanded,
    setGlobalScroll,
    globalScroll,
    density,
    setDensity,
  } = useCJConfigurationDisplay();
  const { t } = useTranslation(['common', 'cahierJournal']);

  return (
    <Dialog
      size="md"
      isOpen={isOpen}
      title={t('cahierJournal:settings.cjView.title')}
      disabledClickOutside={false}
      onClose={onClose}
    >
      <Dialog.Body>
        <div tw="ml-2 space-y-5">
          {!guestMode?.enabled && <CondensedOption />}

          <Cards
            label={t('cahierJournal:settings.cjView.expand.label')}
            cols="1"
            options={[
              {
                value: 'fit',
                title: t('cahierJournal:settings.cjView.expand.fit'),
              },
              {
                value: 'nofit',
                title: t('cahierJournal:settings.cjView.expand.nofit'),
              },
            ]}
            value={expanded ? 'nofit' : 'fit'}
            onChange={value => setItemsExpanded(value === 'nofit')}
          />
          <Cards
            label={t('cahierJournal:settings.cjView.scroll.label')}
            cols="1"
            options={[
              {
                value: 'globalScroll',
                title: t('cahierJournal:settings.cjView.scroll.global'),
              },
              {
                value: 'dayScroll',
                title: t('cahierJournal:settings.cjView.scroll.day'),
              },
            ]}
            value={globalScroll ? 'globalScroll' : 'dayScroll'}
            onChange={value => setGlobalScroll(value === 'globalScroll')}
          />
          <Cards
            label={t('cahierJournal:settings.cjView.density.label')}
            cols="1"
            options={[
              {
                value: 'normal',
                title: t('cahierJournal:settings.cjView.density.normal'),
              },
              {
                value: 'compact',
                title: t('cahierJournal:settings.cjView.density.compact'),
              },
            ]}
            value={density || 'normal'}
            onChange={value =>
              setDensity(value === 'compact' ? 'compact' : 'normal')
            }
          />
        </div>
      </Dialog.Body>
      <Dialog.Footer>
        <Button icon={Check} intent="primary" large onClick={onClose}>
          {t('common:buttons.validate')}
        </Button>
      </Dialog.Footer>
    </Dialog>
  );
}
